import { ButtonProps } from '@chakra-ui/button';
import { Button } from '@telescope/cassini-ui';
import { FaFacebook } from 'react-icons/fa';

type FacebookButtonProps = ButtonProps;

export const FacebookButton = ({ children, ...buttonProps }: FacebookButtonProps) => {
  return (
    <Button
      className="FacebookButton"
      width="full"
      colorScheme="facebook"
      type="button"
      color="white"
      fontWeight={600}
      leftIcon={<FaFacebook className="FacebookButton__icon" />}
      {...buttonProps}>
      {children}
    </Button>
  );
};
